import React from "react";
import dayjs from "dayjs";
import classnames from "classnames";

import "./styles.scss";
import { Typography } from "ct-design";
interface dateprops {
  date: string;
  departDate: string;
  index: string;
  handleClick: (date: string) => void;
  lastElement: boolean;
}
const DateComponent: React.FC<dateprops> = (props) => {
  const { date, departDate, handleClick, index, lastElement } = props;

  const formatDate = (date: string) => {
    return dayjs(date).format("ddd, DD MMM");
  };
  const dateBarItemClassName = classnames(
    "flex flex-middle ta-center py-2 p-relative c-neutral-900 c-pointer",
    {}
  );

  return (
    <div
      className={dateBarItemClassName}
      onClick={() => handleClick(date)}
      key={index}
    >
      <Typography
        variant="HM4"
        className={`fs-3 c-pointer fw-500 px-4 fw-600 ${lastElement ? "" : ""}`}
        data-date={date}
        data-testid="date-val"
        colorCode={departDate === date ? "#1a1a1a" : "#808080"}
        isClickable
      >
        {formatDate(date)}
      </Typography>
      {departDate === date && (
        <p className="dt--active p-absolute w-100p bg-neutral-900 l-0"></p>
      )}
    </div>
  );
};

export default DateComponent;
